import {assert} from 'assert-ts';
import {useAppSelector} from 'store/hooks';
import type {ExpressionV4} from '../types';
import {selectMetadataEditMetadataExpressionById} from '../metadataEditSlice';
import {useCreateSelectorById} from './useCreateSelectorById';

export const useAssertExpressionEdit = (expressionId: string): ExpressionV4 => {
  const selector = useCreateSelectorById(
    expressionId,
    selectMetadataEditMetadataExpressionById,
  );
  const expression = useAppSelector(selector);

  if (!expression) {
    assert(false, 'useAsserExpression: expression not found');
  }

  return expression;
};
